// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
// Registro de novidades por versão. Adicione a nova versão SEMPRE no topo.
export const CHANGELOG = [
  {
    version: '2.3.7',
    date: 'Setembro de 2026',
    items: [
      'Novo formulário digital S-24 (Recibo): preencha, salve na nuvem, baixe em PDF e importe recibos preenchidos fora do sistema',
    ],
  },
  {
    version: '2.3.6',
    date: 'Setembro de 2026',
    items: [
      'Previsão de Gastos automática: ao marcar um S-44 como concluído, o mês correspondente da previsão é atualizado sozinho com o Total das despesas',
    ],
  },
  {
    version: '2.3.5',
    date: 'Setembro de 2026',
    items: [
      'Previsão de Gastos: novo botão "Preencher do S-44" — busca o Total das despesas dos S-44 digitais e preenche os meses do Ano de Serviço automaticamente',
    ],
  },
  {
    version: '2.3.4',
    date: 'Setembro de 2026',
    items: [
      'Manual do Usuário revisado com as novidades: Visita do Viajante, S-26/S-44, importação de PDFs e reabertura de auditoria',
      'Audite mais humana: conversa natural, chama você pelo nome e conhece todas as funções novas do sistema',
    ],
  },
  {
    version: '2.3.3',
    date: 'Setembro de 2026',
    items: [
      'Auditoria Trimestral: agora é possível reabrir uma auditoria finalizada para corrigir e finalizar de novo (com registro no log)',
      'Visita do Viajante: movida para o menu lateral, com escolha da área (Congregação ou Manutenção) e detecção corrigida dos trimestres',
    ],
  },
  {
    version: '2.3.2',
    date: 'Setembro de 2026',
    items: [
      'Visita do Viajante: novo botão em Documentos que compacta os 2 últimos trimestres e envia por e-mail (anexo ou link de download)',
    ],
  },
  {
    version: '2.3.1',
    date: 'Setembro de 2026',
    items: [
      'Melhorias internas de qualidade e organização do código (mais estabilidade e manutenção facilitada)',
      'Nova área para administradores baixarem o pacote Android (.aab) e a política de privacidade da Play Store',
    ],
  },
  {
    version: '2.3.0',
    date: 'Setembro de 2026',
    items: [
      'Importação de relatórios preenchidos fora do sistema (S-25b, S-45b e Folha S-26) com detecção automática do mês',
      'Aviso automático quando uma nova versão do aplicativo é publicada',
      'Cadastro de descrições padrão e sugestões ao digitar os lançamentos do S-26',
      'Símbolo D/J/G/A/R preenchido automaticamente pela descrição do lançamento',
      'Novos símbolos A (Aplicação) e R (Resgate) — movimentações internas não vão para o S-44',
      'Resumo de conferência (totais e avisos) antes de baixar o PDF do S-26',
      'Alerta quando o símbolo do lançamento não combina com o lado do valor',
      'Importação S-26 → S-44 corrigida: lançamentos com o mesmo nome são somados em uma única linha',
    ],
  },
];

export const APP_VERSION = CHANGELOG[0].version;
